import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import LoadingSpinner from '@/components/LoadingSpinner'
import { supportApi } from '@/lib/supportApi'
import { SupportAdminSessionContext } from '@/contexts/SupportAdminSessionContext'

export default function SupportAdminRoute({ children }: { children: React.ReactNode }) {
  const [session, setSession] = useState<Awaited<ReturnType<typeof supportApi.adminSession>> | null>(null)
  const [failed, setFailed] = useState(false)
  useEffect(() => { supportApi.adminSession().then(setSession).catch(() => setFailed(true)) }, [])
  if (!session && !failed) return <div className="flex min-h-[360px] items-center justify-center"><LoadingSpinner size="lg" /></div>
  if (failed || !session?.is_support_admin) return <Navigate to="/support" replace />
  if (session.role === 'sre' && !session.ready) return <Navigate to="/account/security?sre_setup=1" replace />
  return <SupportAdminSessionContext.Provider value={session}>{children}</SupportAdminSessionContext.Provider>
}
